


























































































import { dateToFormatFromIso } from "@common/dateTimeHelper";
import { HeaderSetting, TableClasses, TableSettings } from "@share/common/tables/j-conf-table/types";
import { Component, Prop, Vue } from "vue-property-decorator";

import JConfTableV01 from "@share/common/tables/j-conf-table/virtual/JConfTable-V01.vue";
import TableArrows from "@share/common/table-arrows/TableArrows.vue";
import TicketStatusIcon from "@share/committees/common/components/TicketStatusIcon.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import TabItem, { TabItemData } from "@share/committees/committee/sections/s-3-result/TabItem.vue";

import { ActiveTabHelper } from "@service/components/navbar/helpers/ActiveTabHelper";
import { UserProfile } from "@api/models/UserProfile";
import { ArrayHelpers } from "@common/ArrayHelpers";
import { Debounce } from "vue-debounce-decorator";
import debounce from "lodash.debounce";

import MoreBtn from '../../../../../assets/svg/more.svg';
import { TicketRowInterfaceView } from "@share/committees/common/types/interfaces/TicketsRowInterface";

@Component({ components: { JConfTableV01, TableArrows, TicketStatusIcon, BounceSpinner, TabItem, MoreBtn } })

export default class S3Result extends Vue {

    @Prop({ default: () => [] }) list: TicketRowInterfaceView[];
    @Prop() userProfiles: Record<string, UserProfile>;
    @Prop() isLoading: boolean;

    tableSettings: TableSettings = {minRowHeight: 76};

    containerResizeObserver: ResizeObserver | null = null;

    tableClasses: TableClasses = {
        header: 's-3-result__table-header',
        row: 's-3-result__table-row'
    }

    activeTabHelper: ActiveTabHelper | null = null;
    activeTabId = "";

    showMoreButtonForDesktop = false;
    isMenuOpen = false;
    additionalList: TabItemData[] = [];

    mounted() {
        this.activeTabHelper = new ActiveTabHelper(this as any);

        this.setResizeObserver()
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.containerResizeObserver?.disconnect();
    }

    setResizeObserver() {
        this.resizeHandler();

        if(ResizeObserver) {
            //debounce with decorator does not allow event emit
            const handler = debounce(() => {
                this.resizeHandler()
            }, 50);

            this.containerResizeObserver = new ResizeObserver(handler);
            const container = this.getContainer();
            if(container) {
                this.containerResizeObserver.observe(container);
            }
        }
        else {
            this.addResizeHandler();
        }
    }

    openMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        if (this.isMenuOpen) {
            setTimeout(() => {
                document.body.addEventListener('click', this.handleClick);
            }, 50);
        }
    }

    openTicket(ticket: TicketRowInterfaceView) {
        this.$emit('open', ticket);
    }

    handleClick() {
        this.isMenuOpen = false;
        document.body.removeEventListener('click', this.handleClick);
    }

    getContainer() {
        return this.$el.getElementsByClassName('s-3-result__tabs')[0];
    }

    addResizeHandler() {
        window.addEventListener('resize', this.resizeHandler)

        this.$nextTick(() => {
            this.resizeHandler();
        })
    }

    @Debounce(50)
    resizeHandler() {
        const container = this.getContainer();

        if(container) {
            const listItems = container.getElementsByTagName("li");
            let targetWidth = 0;

            const lastVisibleItemIndex = Array.from(listItems).findIndex((listItem: HTMLElement) => {
                targetWidth+= listItem.clientWidth;
                return container.clientWidth <= targetWidth;
            })

            this.additionalList = this.tabs.slice(lastVisibleItemIndex);
            this.showMoreButtonForDesktop = container.scrollWidth > container.clientWidth;
        }
    }

    selectTab(item: TabItemData) {
        this.activeTabId = item.id;

        this.activeTabHelper?.setUnderscoreToActive();

        this.additionalList.length && this.additionalList.forEach((tab) => tab.active = tab.id === item.id)
    }

    getFormatedDate(dateString: string) {
        return dateToFormatFromIso(dateString, "dd.LL.yyyy");
    }

    get tabs(): TabItemData[] {
        const uniqItemsByStatus = ArrayHelpers.uniqBy<TicketRowInterfaceView, any>(this.list, (item) => item.status.title);

        if(!this.activeTabId && uniqItemsByStatus.length) {
            this.activeTabId = uniqItemsByStatus[0].status.code;
        }

        return uniqItemsByStatus.map((item) => {
            return {
                id: item.status.code,
                title: item.status.title,
                active: this.activeTabId === item.status.code,
                count: this.list.filter((common) => common.status.code === item.status.code ).length
            }
        });
    }

    get currentList() {
        return this.list.filter((item) => item.status.code === this.activeTabId)
    }

    get headerSettings(): HeaderSetting[] {
        return [
            {
                title: this.$t('agenda.form.titles.name').toString(),
                name: "title"
            },
            {
                title: this.$t("tickets.columns.category").toString(),
                name: 'category'
            },
            {   title: this.$t("tickets.columns.status").toString(),
                name: "status"
            },
            {   title: this.$t("tickets.columns.company").toString(),
                name: "company"
            },
            {   title: this.$t("tickets.columns.dateOfSubmission").toString(),
                name: "createdAt"
            },
            {   title: this.$t("tickets.columns.implementationDate").toString(),
                name: "implementedAt"
            }
        ]
    }
}

